import { ProjectAPI, TeamAPI } from "@brg/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

const ORGANIZATIONS_COUNT_TAB = "organizations";

export const fetchTagPageProjectsCount = createAsyncThunk(
    "tagAdmin/fetchTagPageProjectsCount",
    async (args: any) => {
        const { filters, tagId, campusId } = args;

        const projectCounts = await Promise.all(
            filters.map(async (filter: any) => {
                return ProjectAPI.GetList({ ...filter })
                    .then((r) => r.json())
                    .then(({ paging }) => {
                        return {
                            title: filter.requestTab,
                            count: paging?.count,
                        };
                    });
            })
        );

        if (!tagId) {
            return projectCounts;
        }

        try {
            const teamRes = await TeamAPI.GetList({
                tagIds: [tagId],
                limit: 1,
                page: 1,
            }).then((r) => r.json());

            return [
                ...projectCounts,
                {
                    title: ORGANIZATIONS_COUNT_TAB,
                    count: teamRes?.paging?.count,
                },
            ];
        } catch {
            return [
                ...projectCounts,
                { title: ORGANIZATIONS_COUNT_TAB, count: 0 },
            ];
        }
    }
);import { ProjectAPI, TeamAPI } from "@brg/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

const ORGANIZATIONS_COUNT_TAB = "organizations";

export const fetchTagPageProjectsCount = createAsyncThunk(
    "tagAdmin/fetchTagPageProjectsCount",
    async (args: any) => {
        const { filters, tagId, campusId } = args;

        const projectCounts = await Promise.all(
            filters.map(async (filter: any) => {
                return ProjectAPI.GetList({ ...filter })
                    .then((r) => r.json())
                    .then(({ paging }) => {
                        return {
                            title: filter.requestTab,
                            count: paging?.count,
                        };
                    });
            })
        );

        if (!tagId) {
            return projectCounts;
        }

        try {
            const teamRes = await TeamAPI.GetList({
                tagIds: [tagId],
                limit: 1,
                page: 1,
            }).then((r) => r.json());

            return [
                ...projectCounts,
                {
                    title: ORGANIZATIONS_COUNT_TAB,
                    count: teamRes?.paging?.count,
                },
            ];
        } catch {
            return [
                ...projectCounts,
                { title: ORGANIZATIONS_COUNT_TAB, count: 0 },
            ];
        }
    }
);